/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern } from '../../../shared/constants';

@Component({
	selector: 'airport-form',
	templateUrl: './airport-form.component.html',
	styleUrl: './airport-form.component.css'
})
export class AirportFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	countryCodes: any = [];
	countryList: any = [];
	stateList: any = [];
	cityList: any = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			name: ['', [Validators.required, noWhitespaceInRequiredValidator]],
			address: ['', [Validators.required, noWhitespaceInRequiredValidator]],
			country_code: ['', [Validators.required, noWhitespaceInRequiredValidator]],
			phone_number: ['', [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(mobilePattern)]],
			email: ['', [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(emailPattern)]],
			country_id: ['', [Validators.required, noWhitespaceInRequiredValidator]],
			state_id: ['', [Validators.required, noWhitespaceInRequiredValidator]],
			city_id: ['', [Validators.required, noWhitespaceInRequiredValidator]],
		});
		/* this.apiService.getUserAccess().subscribe((data:any) => {
		try {
		const accessObj:any = JSON.parse(data.res[0].UserModuleAccess);
		this.UserModuleAccess = accessObj["Airports"];
		} catch (error) {}
		},(error:any) => {
		this.UserModuleAccess = "NoAccess";
		}); */
	}

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		this.getCountryCodes();
		this.getCountryList();
		if (this.uId) {
			this.getDetails();
		}
	}

	getCountryCodes() {
		this.apiService.countryCodes().subscribe({
			next: (data: any) => {
				data.map((c: any) => {
					c.display = c.dial_code + "(" + c.name + ")"
					return c;
				})
				this.countryCodes = data;
			}, error: () => {
				this.countryCodes = [];
			}
		});
	}

	getCountryList() {
		this.apiService.country().subscribe({
			next: (data: any) => {
				this.countryList = data;
			}, error: () => {
				this.countryList = [];
			}
		});
	}

	getStatesByCountry() {
		if (this.f.country_id.value) {
			this.apiService.stateList(this.f.country_id.value).subscribe({
				next: (data: any) => {
					this.stateList = data;
				}, error: () => {
					this.stateList = [];
				}
			});
		}
	}

	getCitiesByState() {
		if (this.f.state_id.value) {
			this.apiService.cityList(this.f.state_id.value).subscribe({
				next: (data: any) => {
					this.cityList = data;
				}, error: () => {
					this.cityList = [];
				}
			});
		}
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getAirport({ id: this.uId }).subscribe({
			next: (data: any) => {
				const obj = data.data;
				this.moduleForm.setValue({
					name: obj.name,
					address: obj.address,
					country_code: obj.country_code,
					phone_number: obj.phone_number,
					email: obj.email,
					country_id: obj.country_id,
					state_id: parseInt(obj.state_id),
					city_id: parseInt(obj.city_id),
				});
				this.getStatesByCountry();
				this.getCitiesByState();
			}, error: (error) => {
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			name: this.f.name.value,
			address: this.f.address.value,
			country_code: this.f.country_code.value,
			phone_number: this.f.phone_number.value,
			email: this.f.email.value,
			country_id: this.f.country_id.value,
			state_id: this.f.state_id.value,
			city_id: this.f.city_id.value,
		};
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateAirport(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							const val: any = value;
							if (val[0] == "This field must be unique.") {
								val[0] = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val[0];
								const selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val[0], 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						}
						return;
					} else {
						errorMsg = "Airport already exists";
					}
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
